module.exports = __webpack_public_path__ + "static/media/Investor-DAVE FOULKES_INTRO_SOLO_FINAL_1646357160903.e81e1451.vtt";